var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.0067 3.94832L10.465 7.89666C8.45253 8.66332 6.8042 11.04 6.8042 13.2058V28.7308C6.8042 30.2833 7.82003 32.3342 9.06587 33.2542L19.6075 41.1317C21.4667 42.5308 24.5142 42.5308 26.3734 41.1317L36.915 33.2542C38.1609 32.315 39.1767 30.2833 39.1767 28.7308V13.2058C39.1767 11.0592 37.5284 8.66332 35.5159 7.91582L24.9742 3.96749C23.9009 3.54582 22.0992 3.54582 21.0067 3.94832Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 27.2741C20.0675 27.2741 19.7033 27.1399 19.4158 26.8524L16.33 23.7666C15.7741 23.2108 15.7741 22.2908 16.33 21.7349C16.8858 21.1791 17.8058 21.1791 18.3616 21.7349L20.4316 23.8049L27.6575 16.5791C28.2133 16.0233 29.1333 16.0233 29.6891 16.5791C30.245 17.1349 30.245 18.0549 29.6891 18.6108L21.4475 26.8524C21.16 27.1399 20.7958 27.2741 20.4316 27.2741Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.c01647c834c33b8a48bf1a74dc88497a.svg";
export { ForwardRef as ReactComponent };